import React from 'react';
import { ChevronDown } from 'lucide-react';
import useCollapsePref from '../hooks/useCollapsePref';

// Slim collapsible wrapper for card sub-sections. Children stay mounted
// (CSS-hidden) so audio/DOM state inside survives collapse.
export const CollapsibleSection = ({ id, title, icon, badge, defaultOpen = false, children, className = '', testId }) => {
  const [open, toggle] = useCollapsePref(id, defaultOpen);
  return (
    <div className={`rounded-lg border border-white/10 bg-white/[0.03] ${className}`} data-testid={testId || `collapsible-${id}`}>
      <button
        type="button"
        onClick={toggle}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-2 px-3 py-2.5 text-left rounded-lg hover:bg-white/5 transition-colors"
        data-testid={`collapsible-${id}-toggle`}
      >
        <span className="text-white text-sm font-medium flex items-center gap-1.5">
          {icon}
          {title}
        </span>
        <span className="flex items-center gap-2 min-w-0">
          {badge}
          <ChevronDown className={`w-4 h-4 shrink-0 text-white/50 transition-transform ${open ? 'rotate-180' : ''}`} />
        </span>
      </button>
      <div className={open ? 'px-3 pb-3 space-y-4' : 'hidden'}>{children}</div>
    </div>
  );
};

export default CollapsibleSection;
